import { lazy } from 'react'

import { Page } from '@webapp/core/components/Page'
import { useProcurifyIntl, useAppRoutes } from '@webapp/hooks'
import { CreditCardProviderInlineCreate } from '@webapp/modules/vendor'
import messages from './messages'

// Owned by platform/banking alongside the feature set; re-exported here under
// the page's historical names, which the route registry and SettingsRouter use.
export {
  ManageBankCreditCardAccountsTabs as ManagePaymentAccountsPageTabs,
  type ManageBankCreditCardAccountsParams as ManagePaymentAccountsPageParams,
} from '@webapp/platform/banking/feature-sets/ManageBankCreditCardAccountsView/ManageBankCreditCardAccountsTabs'

const ManagePaymentAccountsViewChunk = lazy(() =>
  import('@webapp/platform/banking/feature-sets/ManageBankCreditCardAccountsView').then(
    ({ ManageBankCreditCardAccountsView }) => ({
      default: ManageBankCreditCardAccountsView,
    })
  )
)

export const ManagePaymentAccountsPage = () => {
  const intl = useProcurifyIntl()
  const { url } = useAppRoutes()

  return (
    <Page
      pageTitle={intl.formatMessage(messages.managePaymentAccountsPageTitle)}
      breadcrumbs={[
        {
          link: url('SettingsPage'),
          name: intl.formatMessage(messages.settingsTitle),
        },
        {
          name: intl.formatMessage(messages.managePaymentAccountsPageTitle),
        },
      ]}
    >
      <ManagePaymentAccountsViewChunk
        renderProviderInlineCreate={(props) => (
          <CreditCardProviderInlineCreate {...props} />
        )}
      />
    </Page>
  )
}
